// @flow
/* eslint-disable import/prefer-default-export */
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { BusinessAssociateAgreement } from 'types/businessAssociateAgreement'

export async function getBusinessAssociateAgreement(): Promise<BusinessAssociateAgreement> {
  return await makeGetRequest(ApiBase + `/business_associate_agreement`)
}
